export default __webpack_public_path__ + "static/media/GAM.d56b1441.svg";